export default "__VITE_ASSET__DjRl6T2V__"